<template>
  <pf-flex align-items="flex-start" v-if="login.commerciale">
    <pf-flex-item>
      <pf-avatar :src="avatarUrl"/>
    </pf-flex-item>

    <pf-flex-item>
      {{ $t('Il tuo account manager') }}:<br />
      <strong>{{ login.commerciale.name }}</strong> {{ ' ' }}
      <pf-button variant="link" inline :href="`mailto:${login.commerciale.email}`" :title="login.commerciale.email">
        <template #icon>
          <envelope-icon />
        </template>
      </pf-button>{{ ' ' }}
      <pf-button v-if="login.commerciale.phone" variant="link" inline :href="`tel:${login.commerciale.phone}`" :title="login.commerciale.phone">
        <template #icon>
          <phone-icon />
        </template>
      </pf-button>{{ ' ' }}
      <pf-button v-if="login.commerciale.calendar" variant="link" inline :href="login.commerciale.calendar" target="blank" :title="$t('Organizza un appuntamento')">
        <template #icon>
          <calendar-check-icon />
        </template>
      </pf-button>
    </pf-flex-item>
  </pf-flex>
</template>

<script setup lang="ts">
import { useLoginStore } from '@/store/login';
import EnvelopeIcon from '@vue-patternfly/icons/envelope-icon';
import PhoneIcon from '@vue-patternfly/icons/phone-icon';
import CalendarCheckIcon from '@vue-patternfly/icons/calendar-check-icon';
import md5 from 'nano-md5';
import { computed } from 'vue';

const login = useLoginStore();

// URL fuori dal template: vue-tsc 3.3.13 interpreta il // delle URL nelle prop come commento (vuejs/language-tools#6240)
const avatarUrl = computed(() => login.commerciale ? `https://www.gravatar.com/avatar/${md5(login.commerciale.email)}?s=45&d=retro` : undefined);
</script>
